export default __webpack_public_path__ + "static/media/img-profile4.14adda37.jpg";